/**
 * Get human-readable status label
 */
export const getStatusLabel = (status: string): string => {
  switch (status?.toUpperCase()) {
    case 'SCHED':
      return 'Scheduled';
    case 'VERIFY':
      return 'Verified';
    case 'REG':
      return 'Registered';
    case 'ADMIT':
      return 'Admitted';
    case 'DISC':
      return 'Discharged';
    case 'BILL':
      return 'Billed';
    case 'COMP':
      return 'Completed';
    case 'CANCEL':
      return 'Cancelled';
    default:
      return status || 'Unknown';
  }
};
